import { keepPreviousData as keepPreviousDataFn, useQuery } from '@tanstack/react-query';

import { callGetNFTCollectionDetails } from '@app/client/resources/yat-pages/page-items';

import { type CommonNftQueryOptions } from './types';

export function useCollectionTokensQuery({
    contractAddress = '',
    tokenId = '',
    keepPreviousData = false,
    refetchInterval = false,
}: CommonNftQueryOptions) {
    return useQuery({
        queryKey: ['collection-tokens', contractAddress, tokenId],
        queryFn: ({ signal }) =>
            callGetNFTCollectionDetails({
                query: {
                    includeTopBid: true,
                    includeAttributes: true,
                    tokens: `${contractAddress}:${tokenId}`,
                },
                settings: {
                    signal,
                },
            }),
        retry: false,
        enabled: Boolean(contractAddress && tokenId),
        placeholderData: keepPreviousData ? keepPreviousDataFn : undefined,
        refetchInterval,
    });
}
